import {
  CatalogElementInfo,
  CatalogElementTextures,
  ElementsFactories
} from '@archef2000/react-planner';

const info: CatalogElementInfo = {
  title: 'wall',
  tag: ['wall'],
  description: 'Wall with bricks or painted',
  image: require('./wall.png'),
  visibility: {
    catalog: true,
    layerElementsVisible: true
  }
};

const textures: CatalogElementTextures = {
  bricks: {
    name: 'Bricks',
    uri: require('./textures/bricks.jpg'),
    lengthRepeatScale: 0.01,
    heightRepeatScale: 0.01,
    normal: {
      uri: require('./textures/bricks-normal.jpg'),
      lengthRepeatScale: 0.01,
      heightRepeatScale: 0.01,
      normalScaleX: 0.8,
      normalScaleY: 0.8
    }
  },
  painted: {
    name: 'Painted',
    uri: require('./textures/painted.jpg'),
    lengthRepeatScale: 0.01,
    heightRepeatScale: 0.01,
    normal: {
      uri: require('./textures/painted-normal.jpg'),
      lengthRepeatScale: 0.01,
      heightRepeatScale: 0.01,
      normalScaleX: 0.4,
      normalScaleY: 0.4
    }
  },
  glass: {
    name: 'Glass',
    // 1x1 semi-transparent PNG (light blue tint)
    uri: require('./textures/glass.jpg'),
    lengthRepeatScale: 1,
    heightRepeatScale: 1
  }
};

export default ElementsFactories.WallFactory('wall', info, textures);
